Vue.component('keyQueue', {
  template: templates.keyQueue,
  data() {
    return {
      model: {
        keys: {},
        hasResults: false
      }
    }
  },
  mounted() {
    const c = this;
    c.get();
  },
  methods: {
    get() {
      const c = this;
      let data = {};

      keyService.queue()
        .then(function (response) {
          for (let d of response.data) {
            c.model.hasResults = true;
            for (let d of response.data) {
              data[`${d.id}`] = d;
            }
          }

          twitchAPI.getUsersById(data, function(userData) {

            for (let d of userData) {
              for (let i in data) {
                if (data[`${i}`].twitchId == d.id) {
                  data[`${i}`].twitchDisplayName = d.display_name;
                }
              }
            }
  
            c.model.keys = data;

          });

          setTimeout(function() {
            c.get();
          }, 5000);
        })
        .catch(function (error) {
          c.model.hasResults = false;
          setTimeout(function() {
            c.get();
          }, 5000);
        });
    }, 
    use(id) {
      const c = this;
      keyService.use({id: id})
        .then(function (response) {
          c.model.keys[`${id}`].queue = false;
        })
        .catch(function (error) {
          //console.log(error);
        });
    }, 
    cancel(id) {
      const c = this;

      var result = confirm("Are you sure you want to remove this key from the queue?");
      if (result == true) {
        keyService.cancel({id: id})
          .then(function (response) {
            c.model.keys[`${id}`].queue = false;
          })
          .catch(function (error) {
            //console.log(error);
          });
      }
    }
  }
});